module.exports = __webpack_public_path__ + "static/media/default_order_method.89d281db.png";